<script setup lang="ts">
import Badge from "@/core/components/ui/badge/Badge.vue";
import type {ConversationMessage, RCSOutboundMessage, SMSOutboundMessage} from "@/conversation/interfaces";
import type {RcsPayload} from "@/notification-template/interfaces";
import ConversationSMSContent from "@/conversation/components/ConversationSMSContent.vue";
import ConversationRCSOutboundContent from "@/conversation/components/ConversationRCSOutboundContent.vue";

defineProps<{
    payload: { id: string; title: string };
    repliedTo?: ConversationMessage;
}>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-if="repliedTo"
      class="opacity-50 pointer-events-none border-l-2 border-gray-400 pl-2"
    >
      <ConversationSMSContent
        v-if="repliedTo.direction === 'outbound' && repliedTo.channel === 'sms'"
        :payload="(repliedTo as SMSOutboundMessage).payload"
      />
      <ConversationRCSOutboundContent
        v-else-if="repliedTo.direction === 'outbound' && repliedTo.channel === 'rcs'"
        :payload="(repliedTo as RCSOutboundMessage).payload as RcsPayload"
      />
    </div>

    <Badge variant="secondary" class="self-start text-[10px] px-1.5 py-0">
      RCS
    </Badge>
    <p class="text-sm leading-relaxed">
      {{ payload.title }}
    </p>
  </div>
</template>
